module.exports = __webpack_public_path__ + "static/media/CNX-MIDCAP.5ed37519.txt";